import { ExternalInterface } from "@goodgamestudios/createjs-utilities";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("CoreJS.BasicJSVariables");

export class BasicJSVariables {
    private _initialized: boolean;
    private _journeyHash: string;

    /**
     * Reads URL GET variables and stores them
     */
    public readVariablesFromJavaScript(): Promise<any> {
        // Initialize once
        if (this._initialized) {
            return Promise.resolve("already initialized");
        }

        logger.info("readVariablesFromJavaScript: journeyHash");

        return new Promise((resolve, reject) => {
            ExternalInterface.asyncCall("journeyHash").then(result => {
                logger.info("journeyHash: ", result);

                this._initialized = true;
                this._journeyHash = result;

                resolve(result);
            }).catch(reason => {
                this._initialized = true;

                logger.warn(reason);

                resolve(reason);
            });
        });
    }

    public toString(): string {
        return "journeyHash: " + this._journeyHash;
    }

    public get journeyHash(): string {
        if (!this._initialized) {
            throw new Error("BasicJSVariables is not initialized!");
        }

        return this._journeyHash;
    }
}
